/* eslint no-extend-native: off */

if (!Promise.prototype.finally) {
    Promise.prototype.finally = function(callback) {
        if (typeof callback !== 'function') {
            return this.then(callback, callback);
        }
        const P = this.constructor || Promise;
        return this.then(
            value => P.resolve(callback()).then(() => value),
            err => P.resolve(callback()).then(() => {
                throw err;
            })
        );
    };
}

if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        start = typeof start === 'number' ? start : 0;
        if (start + search.length > this.length) {
            return false;
        }
        return this.indexOf(search, start) !== -1;
    };
}
